import React from "react";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Button from "react-bootstrap/Button";
import person from "../../images/person.png";
import Image from "react-bootstrap/Image";
import homeBanner from "../../images/home-banner.png";
import styles from "./HomeBanner.module.scss";

function HomeBanner() {
  return (
    <div className={styles.bannerItem}>
      <img
        src={homeBanner}
        style={{ objectFit: "cover", width: "100%", height: "100vh" }}
      />

      <div className={`${styles.content} container`}>
        <Row className="h-100 flex-row flex-md-row-reverse">
          <Col md={6} className="my-auto">
            <h3
              className="mb-4 fw-bold"
              style={{ fontFamily: "Lato, sans-serif", fontSize: "2.5rem" }}
            >
              <br />
              <p
                className="pt-1 fw-bold"
                style={{ fontFamily: "Lato, sans-serif", fontSize: "2.5rem" }}
              >
                A Blend of Work and Play
                <br />
                To bring your team together
              </p>
            </h3>
            {/* <Button
              variant="primary"
              className="px-5 fw-bold"
              style={{ fontFamily: "Lato, sans-serif" }}
            >
              Sign up now
            </Button> */}
          </Col>
          <Col md={6} className="mt-auto text-end">
            <Image src={person} className={styles.bannerImageElement} />
          </Col>
        </Row>
      </div>
    </div>
  );
}

export default HomeBanner;
